namespace GeniuzPOS.Member {
    export interface PsMemberTypeForm {
        MemberType: Serenity.StringEditor;
        MemberTypeDesc: Serenity.StringEditor;
        MbPriceFg: Serenity.EnumEditor;
        SellUnitPriceNo: Serenity.EnumEditor;
        MbDiscPs: Serenity.DecimalEditor;
    }

    export class PsMemberTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Member.PsMemberType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!PsMemberTypeForm.init)  {
                PsMemberTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EnumEditor;
                var w2 = s.DecimalEditor;

                Q.initFormType(PsMemberTypeForm, [
                    'MemberType', w0,
                    'MemberTypeDesc', w0,
                    'MbPriceFg', w1,
                    'SellUnitPriceNo', w1,
                    'MbDiscPs', w2
                ]);
            }
        }
    }
}
